export const cleanInputs = () => {
    document.getElementById('color_cod').value = '';
    document.getElementById('color_description').value = '';
}

export const buildCreateColorBody = (company) => {
    return {
        cod: document.getElementById('color_cod').value,
        description: document.getElementById('color_description').value,
        company
    }
}

export const validateCreateColor = (body) => {
    if(body.cod === null || body.cod === ''){
        throw new Error('Referencia vacía');
    }
}